import { useEffect, useRef, useState } from "react";

// Adds .is-visible when the element scrolls into view (drives .reveal CSS).
export const Reveal = ({ children, className = "", delay = 0, as: Tag = "div" }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setVisible(true);
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  const delayClass = delay ? `reveal-delay-${delay}` : "";
  return (
    <Tag ref={ref} className={`reveal ${visible ? "is-visible" : ""} ${delayClass} ${className}`}>
      {children}
    </Tag>
  );
};

export const SectionHead = ({ eyebrow, title, sub, align = "left", dark = false, level = 2 }) => {
  const TitleTag = level === 1 ? "h1" : "h2";
  return (
  <Reveal className={`mb-12 max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && <p className={`eyebrow mb-4 ${dark ? "text-teal-soft" : ""}`}>{eyebrow}</p>}
    <TitleTag
      className={`font-display text-[clamp(30px,4vw,48px)] font-semibold leading-[1.08] tracking-tight ${
        dark ? "text-white" : "text-ink"
      }`}
    >
      {title}
    </TitleTag>
    {sub && (
      <p className={`mt-5 text-base leading-relaxed md:text-lg ${dark ? "text-white/75" : "text-ink/65"}`}>
        {sub}
      </p>
    )}
  </Reveal>
  );
};

export const Logo = ({ dark = false }) => (
  <span className="flex items-center gap-2.5" data-testid="site-logo">
    <span
      className="flex h-9 w-9 items-center justify-center rounded-xl shadow-md"
      style={{ backgroundImage: "linear-gradient(125deg,#0A4D68,#148A9D)" }}
      aria-hidden="true"
    >
      <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 10.5 12 3l9 7.5" />
        <path d="M5 9.5V21h14V9.5" />
        <path d="M9.5 21v-6h5v6" />
      </svg>
    </span>
    <span className={`text-lg font-extrabold tracking-tight ${dark ? "text-white" : "text-ink"}`}>
      HomeAligns
    </span>
  </span>
);
